const RL_Subscription = {
  skuData: {
    "1FM": {
      sku: "1FM",
      title: "Face Mask",
      price: "2.99",
      first_sale_price: "3.99",
      original_price: "5.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_addon_1fm.png?v=1692703687",
    },
    "3FM": {
      sku: "3FM",
      title: "3 Face Masks",
      price: "8.99",
      first_sale_price: "10.00",
      original_price: "15.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_addon_3fm.png?v=1692703687",
    },
    "5FM": {
      sku: "5FM",
      title: "5 Face Masks",
      price: "14.99",
      first_sale_price: "17.00",
      original_price: "25.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_addon_3fm.png?v=1692703687",
    },
    "1DC": {
      sku: "1DC",
      title: "Day Cream",
      price: "24.99",
      first_sale_price: "29.99",
      original_price: "39.99",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_addon_1dc.png?v=1692703687",
    },
    "1NC": {
      sku: "1NC",
      title: "Night Cream",
      price: "24.99",
      first_sale_price: "29.99",
      original_price: "39.99",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_addon_1nc.png?v=1692703687",
    },
    "1DC+1NC": {
      sku: "1DC+1NC",
      title: "Day Cream + Night Cream",
      price: "44.99",
      first_sale_price: "49.99",
      original_price: "79.98",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_addon_1dc+1nc.png?v=1692703687",
    },
    "1BPC": {
      sku: "1BPC",
      title: "Prime Collagen",
      price: "19.99",
      first_sale_price: "29.00",
      original_price: "40.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_addon_1bpc.png?v=1692703687",
    },
    "1FM+1UEM": {
      sku: "1FM+1UEM",
      title: "Face Mask + Under Eye Masks",
      price: "4.99",
      first_sale_price: "6.98",
      original_price: "8.99",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_addon_1fm_1uem.png?v=1692703774",
    },
    "1UEM": {
      sku: "1UEM",
      title: "Under Eye Masks",
      price: "1.99",
      first_sale_price: "2.99",
      original_price: "3.99",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_addon_1uem.png?v=1692703687",
    },
    "3UEM": {
      sku: "3UEM",
      title: "3 Under Eye Masks",
      price: "5.99",
      first_sale_price: "8.99",
      original_price: "11.97",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_addon_3uem.png?v=1692703687",
    },
    "1ES": {
      sku: "1ES",
      title: "Under Eye Cream",
      price: "22.99",
      first_sale_price: "24.99",
      original_price: "29.99",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_addon_1es.png?v=1692703687",
    },
    "1SM": {
      sku: "1SM",
      title: "Silk Sleep Mask",
      price: "8.99",
      first_sale_price: "10.00",
      original_price: "15.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_addon_1sm.png?v=1692703687",
    },
    "3MS": {
      sku: "3MS",
      title: "3 Make Up Remover",
      price: "4.99",
      first_sale_price: "10.00",
      original_price: "15.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_addon_3ms.png?v=1692703687",
    },
    "1MS": {
      sku: "1MS",
      title: "Make Up Remover",
      price: "2.00",
      first_sale_price: "3.50",
      original_price: "5.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_addon_3ms.png?v=1692703687",
    },
    "1BO": {
      sku: "1BO",
      title: "Original Collagen",
      price: "19.99",
      first_sale_price: "29.00",
      original_price: "40.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_1b.png?v=1691376271",
    },
    "2BO": {
      sku: "2BO",
      title: "2 Bottles Original Collagen",
      price: "49.00",
      first_sale_price: "49.00",
      original_price: "80.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_2b.png?v=1691376271",
    },
    "3BO": {
      sku: "3BO",
      title: "3 Bottles Original Collagen",
      price: "69.00",
      first_sale_price: "69.00",
      original_price: "120.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_3b.png?v=1691376271",
    },
    "3BO+GIFTBOX1": {
      sku: "3BO+GIFTBOX1",
      title: "3 Bottles Original Collagen",
      price: "69.00",
      first_sale_price: "69.00",
      original_price: "120.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_3b.png?v=1691376271",
    },
    "4BO": {
      sku: "4BO",
      title: "4 Bottles Original Collagen",
      price: "89.00",
      first_sale_price: "89.00",
      original_price: "160.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_4b.png?v=1691376271",
    },
    "5BO": {
      sku: "5BO",
      title: "5 Bottles Original Collagen",
      price: "99.00",
      first_sale_price: "99.00",
      original_price: "200.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_5b.png?v=1691376271",
    },
    "1BMSM": {
      sku: "1BMSM",
      title: "MSM Collagen",
      price: "19.99",
      first_sale_price: "29.00",
      original_price: "40.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_1bmsm.png?v=1691376271",
    },
    "2BMSM": {
      sku: "2BMSM",
      title: "2 Original Collagen",
      price: "49.00",
      first_sale_price: "49.00",
      original_price: "80.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_2bmsm.png?v=1691376271",
    },
    "3BMSM": {
      sku: "3BMSM",
      title: "3 Bottles MSM Collagen",
      price: "69.00",
      first_sale_price: "69.00",
      original_price: "120.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_3bmsm.png?v=1691376271",
    },
    "4BMSM": {
      sku: "4BMSM",
      title: "4 Bottles MSM Collagen",
      price: "89.00",
      first_sale_price: "89.00",
      original_price: "160.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_4bmsm.png?v=1691376271",
    },
    "5BMSM": {
      sku: "5BMSM",
      title: "5 Bottles MSM Collagen",
      price: "99.00",
      first_sale_price: "99.00",
      original_price: "200.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_5bmsm.png?v=1691376271",
    },
    "2BPC": {
      sku: "2BPC",
      title: "2 Bottles Prime Collagen",
      price: "29.99",
      first_sale_price: "49.00",
      original_price: "80.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/2999primesubs.png?v=1692889775",
    },
  },
  giftSkuData: {
    "1UEM": {
      id: "7613324230811",
      vid: "43253072920731",
      sku: "1UEM",
      value: "£3.99",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_1uem.png?v=1691463771",
    },
    "1FM": {
      id: "7613385998491",
      vid: "43253537374363",
      sku: "1FM",
      value: "£5.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_1fm.png?v=1691463771",
    },
    "1MS": {
      id: "7613386883227",
      vid: "43253543108763",
      sku: "1MS",
      value: "£5.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_1ms.png?v=1691463771",
    },
    "3FM": {
      id: "7613386915995",
      vid: "43253544419483",
      sku: "3FM",
      value: "£15.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_3fm.png?v=1691463771",
    },
    "3UEM": {
      id: "7613387210907",
      vid: "43253545304219",
      sku: "3UEM",
      value: "£11.97",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_3uem.png?v=1691463771",
    },
    "2NF": {
      id: "7613387243675",
      vid: "43253546778779",
      sku: "2NF",
      value: "£2.49",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_2nf.png?v=1691463771",
    },
    "1ES": {
      id: "7613387538587",
      vid: "43253548318875",
      sku: "1ES",
      value: "£29.99",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_1es.png?v=1691463771",
    },
    "1DC": {
      id: "7613387604123",
      vid: "43253549531291",
      sku: "1DC",
      value: "£40.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_1dc.png?v=1691463771",
    },
    "1NC": {
      id: "7613387899035",
      vid: "43253550973083",
      sku: "1NC",
      value: "£40.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_1nc.png?v=1691463771",
    },
    "5FM": {
      id: "7613394256027",
      vid: "43253592653979",
      sku: "5FM",
      value: "£25.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_5fm.png?v=1691463771",
    },
    "2UEM": {
      id: "7697328111771",
      vid: "43521389527195",
      sku: "2UEM",
      value: "£7.98",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_2uem.png?v=1691463771",
    },
    "4NF": {
      id: "7697328111771",
      vid: "43521393328283",
      sku: "4NF",
      value: "£4.98",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_4nf.png?v=1691463771",
    },
    "3MS": {
      id: "7697331486875",
      vid: "43521406304411",
      sku: "3MS",
      value: "£15.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_3ms.png?v=1691463771",
    },
    "1SM": {
      id: "7697333059739",
      vid: "43521415577755",
      sku: "1SM",
      value: "£15.00",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_1sm.png?v=1691463771",
    },
    "12OFF": {
      id: "",
      vid: "",
      sku: "discount",
      value: "",
      img: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_12off.png?v=1691463771",
    },
  },
  giftListData: {
    "1b": [
      { gifts: null },
      { gifts: null },
      { gifts: ["1ES"] },
      { gifts: null },
      { gifts: null },
      { gifts: ["1NC"] },
    ],
    "2b": [
      { gifts: ["1FM"] },
      { gifts: ["1FM"] },
      { gifts: ["3FM"] },
      { gifts: ["1NC"] },
      { gifts: ["1FM"] },
      { gifts: ["1FM"] },
      { gifts: ["3FM"] },
      { gifts: ["3UEM"] },
    ],
    "3b": [
      { gifts: ["1FM"] },
      { gifts: ["1FM"] },
      { gifts: ["3FM"] },
      { gifts: ["1NC"] },
      { gifts: ["4NF", "1MS"] },
      { gifts: ["12OFF"] },
      { gifts: ["1SM"] },
      { gifts: ["1ES"] },
    ],
    "5b": [
      { gifts: ["3FM"] },
      { gifts: ["1SM", "4NF"] },
      { gifts: ["1NC"] },
      { gifts: ["5FM"] },
      { gifts: ["12OFF"] },
      { gifts: ["1ES"] },
    ],
    "3b_life": [
      { gifts: null },
      { gifts: ["1UEM"] },
      { gifts: ["3FM"] },
      { gifts: ["1MS"] },
      { gifts: ["1ES"] },
    ],
  },
  getFirstGiftVid: function (bottle) {
    return RL_Subscription.giftSkuData[
      RL_Subscription.giftListData[bottle][0].gifts[0]
    ].vid;
  },
};
//console.log(RL_Subscription.giftSkuData[RL_Subscription.giftListData["3b"][0].gifts[0]]);
